module.exports = __webpack_public_path__ + "static/LH-logo-large-ed46826f9fbdd8a7d9978d26bfe70afc.svg";